import { FC, ReactNode } from 'react';

import styles from './index.module.scss';

type Props = {
  children: ReactNode;
};

export const EndUserLayout: FC<Props> = ({ children }) => {
  return <div className={styles.endUserRoot}>{children}</div>;
};
